export enum UnappliedFundsBannerVariant {
  HOME = 'HOME',
  INLINE = 'INLINE',
}

export interface UnappliedPushTotalBalance {
  amount: number;
  organizationNames: string[];
  organizationsCount: number;
}
